/**
 * Restores activeTeam and activeSeason from Dexie after a sync.
 * Always refreshes from the DB so synced changes are picked up immediately.
 */
import { db } from './db'
import { useAppStore } from '@/store/appStore'

export async function restoreActiveState(): Promise<void> {
  const { activeTeam, activeSeason, setActiveTeam, setActiveSeason } = useAppStore.getState()

  if (activeTeam) {
    const fresh = await db.teams.get(activeTeam.id)
    if (fresh) setActiveTeam(fresh)
  } else {
    const teams = await db.teams.toArray()
    const team = teams.sort((a, b) => b.updatedAt.localeCompare(a.updatedAt))[0]
    if (team) setActiveTeam(team)
  }

  const teamId = useAppStore.getState().activeTeam?.id
  if (teamId) {
    if (activeSeason) {
      const fresh = await db.seasons.get(activeSeason.id)
      if (fresh) setActiveSeason(fresh)
    } else {
      const season =
        await db.seasons.where('teamId').equals(teamId).filter(s => s.isActive).first()
        ?? await db.seasons.where('teamId').equals(teamId).sortBy('year').then(a => a[a.length - 1])
      if (season) setActiveSeason(season)
    }
  }
}
